<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4 *ngIf="listType === 'max-hops'">Exceeding max hops locations</h4>
        <h4 *ngIf="listType === 'max-links'">Exceeding max links locations</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross" />
        </button>
    </div>
    <div #preloaderTarget class="preloader-target">
        <div *ngIf="nodesList" class="modal-body modal-body--fixed-header">
            <div class="modal-body__fixed-header">
                <winde-tabs-nav
                    (tabChanged)="changeTab($event)"
                    *ngIf="tabsToShow && tabsToShow.length > 0"
                    [activeTab]="currentTab"
                    [customClass]="'tabs-nav--doc-tabs mb-1'"
                    [tabsList]="tabsToShow"
                    [translationPrefix]="'project.reportsTabs'"
                >
                </winde-tabs-nav>
            </div>
            <div class="modal-body__scroll-content pt-3">
                <h6 class="devices-list-title">Locations ({{ nodesList.length }})</h6>
                <div class="devices-list">
                    <div class="grid">
                        <!-- HEADER -->
                        <div class="grid-row">
                            <div class="grid-row__cell location-cell">Location</div>
                            <div *ngIf="layers" class="grid-row__cell">Layer</div>
                            <div class="grid-row__cell state-cell">Frozen / Installed</div>
                        </div>

                        <!-- BODY -->
                        <div
                            *ngFor="let station of nodesList; trackBy: trackNodesData"
                            [ngClass]="{ 'highlight-substring--blue': selectedNodes.indexOf(station.nodeid) !== -1 }"
                            class="grid-row"
                        >
                            <div class="grid-row__cell location-cell">
                                <winde-node-pointer
                                    [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 20 }"
                                ></winde-node-pointer>
                            </div>
                            <div *ngIf="layers" class="grid-row__cell">{{ layers[this.getNodeLayerIndex(station.nodeid)] }}</div>
                            <div class="grid-row__cell state-cell">
                                @if (station.isUserForced && !station.isInstalled) {
                                    <button windeActionIcon>
                                        <sui-svg-icon icon="lock" windeGrey />
                                    </button>
                                }
                                @if (station.isUserForced && station.isInstalled) {
                                    <button windeActionIcon>
                                        <sui-svg-icon icon="podcast" windeGrey />
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
